import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-unassingned-task-confirmation-dialog',
  templateUrl: './unassingned-task-confirmation-dialog.component.html',
  styleUrls: ['./unassingned-task-confirmation-dialog.component.scss']
})
export class UnassingedTaskConfirmationDialogComponent implements OnInit {

  constructor(
    readonly dialogRef: MatDialogRef<UnassingedTaskConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }) { }

  ngOnInit(): void { }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.dialogRef.close(true);
  }
}
